import global from "./global";
import proctoring from "./proctoring/index";
import sidebars from "./sidebars";
import alerts from "./alerts";
import subjects from "./subjects";
import user from "./user";
// import grid from "./grid";
import kbase from "./kbase";
import subject from "./subject";
import notifications from "./notifications";
import supportModal from "./supportModal";
import dataContacts from "./sidebarData/contacts"

//workflow
import state_files from "./workflow/state_files";
import state_comment from "./workflow/state_comment";
import login from "./login";
import mySubjects from "./mySubjects";
import form from "./form";
import lessonsCreateFilters from "./lessonsCreateFilters";
import sidebarResource from "./sidebarResource";
import complect from "./complect";

const modules = {
  global,
  proctoring,
  sidebars,
  user,
  alerts,
  subjects,
  state_files,
  state_comment,
  // grid,
  kbase,
  subject,
  notifications,
  supportModal,
  dataContacts,
  login,
  mySubjects,
  form,
  lessonsCreateFilters,
  sidebarResource,
  complect,
};

// const StoreNamespaces = Object.keys(modules);

// export { StoreNamespaces }
export default modules;

